import { render, staticRenderFns } from "./ResortFields.vue?vue&type=template&id=71037d50&"
import script from "./ResortFields.vue?vue&type=script&lang=js&"
export * from "./ResortFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports